// extracted by mini-css-extract-plugin
export default {"sliderRow":"Slider_sliderRow__eSXz5","sliderLabel":"Slider_sliderLabel__rDpEW","slider":"Slider_slider__jHibB","sliderValue":"Slider_sliderValue__Tb7+Q"};